"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachmentSchema = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var Joi = require('joi').extend(require('@joi/date'));
exports.attachmentSchema = Joi.object({
    description: Joi.string()
        .min(0)
        .max(150)
        .optional()
        .when('documentType', {
        is: claim_domain_1.ClaimDocumentType.Miscellaneous,
        then: Joi.required(),
        otherwise: Joi.optional().allow(''),
    }),
    documentType: (_a = Joi.string()).valid.apply(_a, Object.values(claim_domain_1.ClaimDocumentType)),
});
exports.default = { attachmentSchema: exports.attachmentSchema };
